import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo,
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { Component } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import DateBox from 'devextreme-react/date-box';
import { SelectBox } from 'devextreme-react/select-box';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions';
import { StatusType, DateFormat } from '../../helpers/fixcodes';
import { LoadPanel } from 'devextreme-react/load-panel';
const position = { of: '#historydiv' };

export class VehicleTripFareSummaryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSubmited: false,
            isOpenModal: false,
            loadPanelVisible: false,

            dropdownPayRollDate: [],
            payEndDate: '',
            invoiceReceiptVoucher: [],
            errors: {
                payEndDate: '',
            }
        }

        this.getPayPeriod = this.getPayPeriod.bind(this);
        this.handlePayPeriodChange = this.handlePayPeriodChange.bind(this);

        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);

        this.handleSearchAccountPaySummaryReportSubmit = this.handleSearchAccountPaySummaryReportSubmit.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);

        this.emailReports = this.emailReports.bind(this);
        this.getInvoiceReceiptVoucherReport = this.getInvoiceReceiptVoucherReport.bind(this);
    }

    async componentDidMount() {
        this.setState({
            loadPanelVisible: true,
        });
        await this.getPayPeriod();
        this.setState({
            loadPanelVisible: false,
        });
    }


    onToolbarPreparing(e) {

        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'email',
                onClick: this.emailReports.bind(this),
                hint: 'Email'
            }
        });

        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'refresh',
                onClick: this.getInvoiceReceiptVoucherReport.bind(this),
                hint: 'Refresh'
            }
        });
    }

    async getPayPeriod() {
        try {
            var request = new Object();
            request.VehicleId = 0;
            request.VehicleOwnerId = 0;
            request.PayDate = '';
            request.ChequeNo = '';
            request.IsTransactionType = true;
            request.PayrollType = 0;
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('vehicle-payment-api/payroll-pedriod-dropdown/', requestParams);
            const data = await response.json();
            if (data !== null && data.vehiclePayRollPeriods.length > 0) {
                this.setState({
                    dropdownPayRollDate: data.vehiclePayRollPeriods
                });
            }

        } catch (e) {
            console.log(e);
        }
    }

    async emailReports() {
        const isValid = await Swal.fire({
            title: "<small>Pending Implementation</small>",
            text: "This feature is comming soon.",
            icon: "info",
            dangerMode: false,
            width: "25%",
            dangerMode: false,
            allowOutsideClick: false
        });
        return;
    }

    async getInvoiceReceiptVoucherReport() {

        var request = new Object();
        request.LocationId = Number(sessionStorage.getItem("session_locationId"));
        request.payDate = this.state.payEndDate;

        try {
            this.setState({
                isSubmited: true,
            });
            const requestParams = getRequestParams('POST', request);
            const response = await fetch('report-api/vehicle-wise-pay-roll', requestParams);
            const data = await response.json();
            this.setState({
                invoiceReceiptVoucher: data.rptVehicleWisePayRoll
            });
            this.setState({ isSubmited: false });

        } catch (e) {
            this.setState({ isSubmited: false });
        }

    }

    handlePayPeriodChange =(selectedOption)=>{
        try {
            let errors = this.state.errors;
            errors.payEndDate = '';
            let payEndDate = '';
            if (selectedOption !== null && selectedOption.selectedItem !== null) {
                payEndDate = selectedOption.selectedItem.payDate === null ? '' : selectedOption.selectedItem.payDate;
            }
            this.setState({ payEndDate: payEndDate, errors: errors });
        } catch (ex) {
            console.log(ex);
        }
    }

    async handleSearchAccountPaySummaryReportSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            await this.getInvoiceReceiptVoucherReport();
            //this.downloadAccountPaymentTypeSummaryAsPdf();
        }
    }
    handleClearSearch() {
        this.setState({
            isSubmited: false,
            isOpenModal: false,
            loadPanelVisible: false,

            payEndDate: '',
            invoiceReceiptVoucher: [],
            errors: {
                payEndDate: '',
            }
        });
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.customerCode = "";
        errors.invoiceNumber = "";

        if (this.state.payEndDate == "") {
            formIsValid = false;
            errors.payEndDate = "Please select pay roll date.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    render() {
        const renderGridCurrencyCell = (data) => {
            return <div>${parseFloat(data.value).toFixed(2)}</div>;
        }

        return (

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-sm-6 col-md-6 col-lg-6">
                                <h1 className="m-0 text-dark">Vehicle Trip Fare Summary</h1>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <ol className="breadcrumb float-sm-right">
                                    <NavItem> <NavLink tag={Link} to="/report" className="btn btn-block btn-outline-secondary btn-sm" title="Reports" ><i className="fas fa-arrow-left"></i> Back</NavLink></NavItem>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <form method="post" onSubmit={this.handleSearchAccountPaySummaryReportSubmit} style={(this.state.isSubmited) ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                    <div className="rez-header">
                        <div className="container">
                            <div className="row">

                                <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <label>Pay Roll Date</label>
                                        <SelectBox
                                            dataSource={this.state.dropdownPayRollDate}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Select payroll date"
                                            name="ddpayroll"
                                            defaultValue={''}
                                            value={this.state.payEndDate}
                                            displayExpr='viewDate'
                                            valueExpr='payDate'
                                            onSelectionChanged={this.handlePayPeriodChange}
                                            showClearButton={true}
                                            disabled={false}
                                            searchEnabled={true}
                                        />
                                        {this.state.errors["payEndDate"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["payEndDate"]}</span>}
                                    </div>
                                </div>
                                <div className="col-lg-9 col-md-9 col-sm-9 col-xs-9">
                                    <div className="form-group">
                                        <label className="btn-block">&nbsp;</label>
                                        <button type="submit" className="btn btn-success btn-sm" onClick={this.handleSearchAccountPaySummaryReportSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                                            {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                            {!this.state.isSubmited && <span title="Search"><i className="fas fa-search"></i> Search</span>}
                                        </button>&nbsp; &nbsp;
                                        <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleClearSearch} title="Clear"><i className="fas fa-eraser"></i> Clear</button>&nbsp; &nbsp;
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
                <div className="content">
                    <div className="card">
                        <div className="card-body">
                            <DataGrid
                                dataSource={this.state.invoiceReceiptVoucher}
                                keyExpr="vehicleNo"
                                columnsAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                allowColumnResizing={true}
                                columnResizingMode='widget'
                                onToolbarPreparing={this.onToolbarPreparing}>
                                <Column dataField="vehicleNo" caption="Vehicle Number" width={200} allowFiltering={true} allowSorting={true} />
                                <Column dataField="totalFare" caption="Total Amount" allowSorting={true} cellRender={renderGridCurrencyCell} />

                                <SortByGroupSummaryInfo summaryItem="count" />
                                <GroupPanel visible={false} />
                                <HeaderFilter visible={false} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                <Grouping autoExpandAll={true} />
                                <Paging defaultPageSize={20} />
                                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 50, 500]} showInfo={true} visible={true}/>
                                <Export enabled={true} allowExportSelectedData={false} />
                                <ColumnChooser enabled={false} />
                                <ColumnFixing enabled={false} />
                            </DataGrid>
                        </div>
                    </div>

                </div>
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={false}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div >
        )
    }
}